var mousetimeout;
var screensaver_active = false;
var idletime = 5;

function show_screensaver(){
    $(".ScreenSlider").fadeIn();
    screensaver_active = true;
}

function stop_screensaver(){ 
    $(".ScreenSlider").fadeOut();
    screensaver_active = false;
}

$(document).mousemove(function(){
    clearTimeout(mousetimeout);
	
    if (screensaver_active) {
        stop_screensaver();
    }

    mousetimeout = setTimeout(function(){
        show_screensaver();
    }, 3000 * idletime); // 5 secs			
});

$("html").mouseenter(function(){
    $(".ScreenSlider").fadeOut();
});


